var v1="<ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li ng-repeat=\"item in vm.subNav.navObj track by $index\" ng-class=\"{active: item.active }\"> <a href=\"\" ng-click=\"vm.showTab(item.link)\">{{ item.name }}</a> </li> </ul>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaSubNav.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaSubNav/lbaSubNav.html
// module id = 324
// module chunks = 0